import React from 'react';
import { DeclinationContext, IDeclinationContextValue } from './context';

export const useDeclination = (): IDeclinationContextValue['declination'] => {
  const context = React.useContext(DeclinationContext);
  return context.declination;
};
